import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SoilBand } from './ui/SoilBand';
import { productImage, productName } from '../data/offer';
const guarantees = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-field-deep" data-id="element-127" data-mp="sa9slf0wlvx6">
      <SoilBand data-id="element-128" data-mp="ncq0bb7dfim8" />

      <div className="mx-auto max-w-6xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-16" data-id="element-129" data-mp="nb6ktmtjhbli">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-gold/40 bg-field px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-130" data-mp="3d1scj2wkntvr">
          {productName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.06] text-cream sm:text-6xl" data-id="element-131" data-mp="39auqrc9b5kwp">
          Del descubrimiento a la producción.<br data-id="element-132" data-mp="35a2gcfop99yu" />
          <span className="text-gold" data-id="element-133" data-mp="35audhuxy3fr8">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-134" data-mp="2qlepuntpnqfr">
          <img src={productImage} alt="Megapack Yacimientos de Hidrocarburos Listo: nueve tomos y cinco bonos para docentes de Yacimientos de Hidrocarburos en Argentina" className="mx-auto w-full drop-shadow-2xl" data-id="element-135" data-mp="2lkilk95g629t" />
        </motion.div>

        <ul className="mt-8 flex flex-wrap justify-center gap-2 text-xs font-bold text-cream" data-id="element-136" data-mp="ic86b9pp1wv7">
          {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <li key={item} className="inline-flex items-center gap-1.5 rounded-md border border-field-light/30 bg-field px-3 py-2" data-id="element-137" data-mp="db2dlbw1a9lo">
              <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-138" data-mp="1622l3wtkpvi3" />
              {item}
            </li>)}
        </ul>

        <div className="mt-7" data-id="element-139" data-mp="11150zep06rdy">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-140" data-mp="114kkctppmml6">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-field-light" data-id="element-141" data-mp="3ltglflt1eim8">
          {guarantees.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="3htpzbveggqo1">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-143" data-mp="1xb5omas9olej" /> {label}
            </span>)}
        </div>

        <p className="mx-auto mt-5 inline-flex max-w-2xl items-start gap-2 text-left text-xs font-semibold text-field-light" data-id="element-144" data-mp="218jzs7zid396">
          <UsersIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-145" data-mp="2b198iv3oc30t" />
          Para docentes, instructores y formadores de escuelas técnicas, formación profesional y espacios de Yacimientos
          de Hidrocarburos de toda Argentina
        </p>
      </div>
    </section>;
}